<template>
    <a class="alert-link">
        <slot />
    </a>
</template>

<script>
export default {

    name: 'AlertLink'

};
</script>
